module.exports = __webpack_public_path__ + "img/9.8d90a0ce.png";